// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qf-1";
export var stateContainer = "_qf-0";